__turbopack_context__.v({
  "accordionSlideOverwrite": "userActionToolbar-module-scss-module__AuFofG__accordionSlideOverwrite",
  "fadeIn": "userActionToolbar-module-scss-module__AuFofG__fadeIn",
  "fadeOut": "userActionToolbar-module-scss-module__AuFofG__fadeOut",
  "scaleIn": "userActionToolbar-module-scss-module__AuFofG__scaleIn",
  "scaleOut": "userActionToolbar-module-scss-module__AuFofG__scaleOut",
  "userActionToolbar": "userActionToolbar-module-scss-module__AuFofG__userActionToolbar",
  "zoomIn": "userActionToolbar-module-scss-module__AuFofG__zoomIn",
  "zoomOut": "userActionToolbar-module-scss-module__AuFofG__zoomOut",
});
